import React from "react";
import paypalIcon from "@/public/fallbacks/paypal-new.svg";
import { useTemplateStore } from "@/zustand/templateStore";

const paypalBtnStyles = window?.post_template?.checkout_v4_global_components;

const PaypalButton = ({ margin, modifications, submitFunc, trigger, showTermsBox, control }) => {
  const { handlePaymentMethodChange } = useTemplateStore();
  const paypalUpper = window.post_template?.checkout_v4_form?.tr_checkout_v4_paypal_upper;
  const paypalBottom = window.post_template?.checkout_v4_form?.tr_checkout_v4_paypal_bottom;

  const paypalStyles = {
    "--paypalBackground": paypalBtnStyles.checkout_v4_components_paypalBackground,
    "--paypalHover": paypalBtnStyles.checkout_v4_components_paypalBackgroundHover,
    "--paypalShadow": paypalBtnStyles.checkout_v4_components_paypalShadowColor,
    "--paypalShadowHover": paypalBtnStyles.checkout_v4_components_paypalShadowColorHover,
    "--paypalTextColor": paypalBtnStyles.checkout_v4_components_paypalTextColor,
    marginTop: margin,
  };

  const handlePaypalSubmit = async (e) => {
    e.preventDefault();
    const isChecked = await trigger("policy");

    if (!isChecked && showTermsBox) {
      // Scroll to the policy checkbox
      const policyInput = document.getElementsByName("policy")[0];
      if (policyInput) {
        policyInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        return;
      }

      setTimeout(() => {
        if (control) {
          control.unregister("policy");
          control.register("policy");
        }
      }, 3000);
    }

    submitFunc();

    handlePaymentMethodChange("paypal");
  };

  return (
    <div className={`submitPaypal__wrapper ${modifications?.noBorders && "submitPaypal__wrapper__noBorders"}`}>
      <div
        className={`submitPaypal__container ${modifications?.noBorders && "submitPaypal__container__noBorders"} ${window.enhancedContrast && "enhancedContrast"}`}
        data-before={paypalUpper}
        data-after={paypalBottom}
      >
        <button
          data-testid="cc-complete-paypal-order"
          onClick={handlePaypalSubmit}
          style={paypalStyles}
          formNoValidate
          type="button"
          className="submitPaypal submitPaypal--active"
        >
          <img src={paypalIcon} className="submitPaypal__paypalLogo" alt="PayPal" />
        </button>
      </div>
    </div>
  );
};

export default PaypalButton;
